import React from 'react'
import Layer from './Layer'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON'
import { Style, Stroke, Fill, Icon, Text, Circle } from 'ol/style'
// import gridsGeoJSONUrl from '../resources/layers/grids.geojson'
// import microbaciasGeoJSONUrl from '../resources/layers/microbaciasSimplificada_000100.geojson'
import mining from "../assets/mining.svg";
import FeatureSummary from './FeatureSummary'
import LayerLegend from './LayerLegend';
import LayerLegendItem from './LayerLegendItem';
import { Grids, EstradasSimplificada, RedesDeDrenagemSimplificada, UnidadesConservacao, TerrasIndigenas, Minas, MicrobaciasSimplificada_000100, Geologia, ShapeAnaliseSolo, GrupoAnaliseSolo, ShapeAnaliseContrasteSolo, GruposAnaliseContrasteSolo } from '../config/api'
import Analise from './Analise'
import { tipoLimiarColorsForMap } from './UtilCoresLimiares'

class LayerRegistry {
	constructor() {
		this.initLayers();
		this.allLayers = this.findAllLayers();
	}

	findAllLayers = () => Object.keys(this)
		.filter(key => this[key] instanceof Layer)
		.map(key => this[key]);

	findLayerById = (layerId) => this.allLayers.find(layer => layer.id === layerId);

	findLayerByOLLayer = (olLayer) => this.findLayerById(Layer.getLayerIdFromOLLayer(olLayer));

	initLayers = () => {
		this.grids = this.createGridsLayer();
		this.microbacias = this.createMicrobaciasLayer();
		this.microbaciasAnalise = this.createMicrobaciasAnaliseLayer();
		this.estradas = this.createEstradasSimplificadaLayer();
		this.redesDeDrenagem = this.createRedesDeDrenagemSimplificadaLayer();
		this.redesDeDrenagemAnalise = this.createRedesDeDrenagemSimplificadaAnaliseLayer();
		this.unidadesConservacao = this.createUnidadeConservacaoLayer();
		this.terrasIndigenas = this.createTerrasIndigenasLayer();
		this.minas = this.createMinasLayer();
		this.amostras = this.createAmostraLayer();
        this.geologia = this.createGeologiaLayer();
	}

	setLimilarLayer = (limiarLayer) => {
		this.limiarLayer = limiarLayer;
		this.allLayers = this.findAllLayers()
    }
    
    setSoloLayer = (soloLayer) => {
        this.solo = soloLayer;
        this.allLayers = this.findAllLayers()
    }

	static loaderFeatureFromAPI = async (vectorLayer, service) => {
		const features = await service()
		vectorLayer.getSource().addFeatures(
			vectorLayer.getSource().getFormat().readFeatures(features)
		);
	}

	static loaderFeatures = async (vectorLayer, dados) => {
		vectorLayer.getSource().addFeatures(
			vectorLayer.getSource().getFormat().readFeatures(dados)
		);
	}

	createGridsLayer = () => {
		return new Layer({
			name: 'Quadrículas',
			multipleFeaturesSelection: false,
			doCreateOLLayer: function () {
				const vectorLayer = new VectorLayer({
					source: new VectorSource({
						format: new GeoJSON(),
						loader: () => LayerRegistry.loaderFeatureFromAPI(vectorLayer, Grids)
					}),
					style: new Style({
						stroke: new Stroke({
							color: 'gray',
							width: 0.5
						}),
						//o método map.forEachFeatureAtPixel() não retorna features sem preenchimento (fill), por isso usamos preenchimento invisível (branco com alpha 0)
						fill: new Fill({ color: [255, 255, 255, 0] })
					}),
					zIndex: 1
				});
				return vectorLayer
			},
			doCreateLegend: function () {
				return new LayerLegend({
					title: "Quadrículas",
					order: 2,
					items: [
						new LayerLegendItem({
							description: 'Legenda 1',
							icon: 'rectangle',
							color: 'white',
							isAssociatedWithFeature: (feature) => true
						})
					]
				});
			},
			createFeatureSummary: function (feature) {
				return new FeatureSummary({
					element: (<div key={`${this.id}_${feature.getId()}`}>{feature.get('COD_AMOS_1')}</div>),
					order: 10
				});
			}
		})
	}

	createMicrobaciasLayer = () => {
		return new Layer({
			name: 'Microbacias',
			doCreateOLLayer: function () {
				const vectorLayer = new VectorLayer({
					source: new VectorSource({
						format: new GeoJSON(),
						loader: () => LayerRegistry.loaderFeatureFromAPI(vectorLayer, MicrobaciasSimplificada_000100),
					}),
					style: new Style({
						stroke: new Stroke({
							color: '#7796CB',
							width: .7
						}),
						//o método map.forEachFeatureAtPixel() não retorna features sem preenchimento (fill), por isso usamos preenchimento invisível (branco com alpha 0)
						fill: new Fill({ color: [255, 255, 255, 0] })
					}),
					zIndex: 2
				});
				return vectorLayer
			},
			doCreateLegend: function () {
				return new LayerLegend({
					title: " ",
					order: 2,
					items: [
						new LayerLegendItem({
							description: 'Microbacias',
							icon: 'polygon',
							color: 'blue',
							isAssociatedWithFeature: (feature) => true
						})
					]
				});
			},
			createFeatureSummary: function (feature) {
				return new FeatureSummary({
					element: (<div key={`${this.id}_${feature.get('FID_1')}`}>{`MB${feature.get('FID_1')}`}</div>),
					order: 20
				});
			}
		});
	}

	createMicrobaciasAnaliseLayer = () => {
		return new Layer({
			name: 'Analises Microbacias',
			disableSelect: false,
			multipleFeaturesSelection: true,
			doCreateOLLayer: function () {
				const vectorLayer = new VectorLayer({
					source: new VectorSource({
						format: new GeoJSON(),
						loader: () => LayerRegistry.loaderFeatureFromAPI(vectorLayer, MicrobaciasSimplificada_000100)
					}),
					style: null,
					zIndex: 1
				});
				return vectorLayer
			},
			createFeatureSummary: function (feature) {
				const overlayText = Analise.getInstance().getTextToOverlay(feature)

				return new FeatureSummary({
					element: (
						<div key={`${this.id}_${feature.get('FID_1')}`}>
							<label>
								MB{feature.get('FID_1')}
							</label>
							<br />
							<div style={{ marginLeft: 10 }}>
								{overlayText}
							</div>
						</div>),
					order: 20
				});
			}
		});
	}

	createEstradasSimplificadaLayer = () => {
		return new Layer({
			name: 'Estradas',
			disableSelect: true,
			doCreateOLLayer: function () {
				const vectorLayer = new VectorLayer({
					source: new VectorSource({
						format: new GeoJSON(),
						loader: () => LayerRegistry.loaderFeatureFromAPI(vectorLayer, EstradasSimplificada)
					}),
					style: new Style({
						stroke: new Stroke({
							color: 'black',
							width: 0.8
						})
					}),
					zIndex: 2
				});
				return vectorLayer
			},
			doCreateLegend: function () {
				return new LayerLegend({
					title: " ",
					order: 2,
					items: [
						new LayerLegendItem({
							description: 'Estradas',
							icon: 'line',
							color: 'black',
							isAssociatedWithFeature: (feature) => true
						})
					]
				});
			}
		});
	}

	createRedesDeDrenagemSimplificadaLayer = () => {
		return new Layer({
			name: 'Redes de Drenagem',
			disableSelect: true,
			doCreateOLLayer: function () {
				const vectorLayer = new VectorLayer({
					source: new VectorSource({
						format: new GeoJSON(),
						loader: () => LayerRegistry.loaderFeatureFromAPI(vectorLayer, RedesDeDrenagemSimplificada)
					}),
					style: new Style({
						stroke: new Stroke({
							color: '#30819c',
							width: 0.8
						})
					}),
					zIndex: 2
				});
				return vectorLayer
			},
			doCreateLegend: function () {
				return new LayerLegend({
					title: " ",
					order: 2,
					items: [
						new LayerLegendItem({
							description: 'Redes de drenagem',
							icon: 'line',
							color: 'blue',
							isAssociatedWithFeature: (feature) => true
						})
					]
				});
			}
		});
	}

	createRedesDeDrenagemSimplificadaAnaliseLayer = () => {
		return new Layer({
			name: 'Analises RedesDrenagem',
			disableSelect: false,
			doCreateOLLayer: function () {
				const vectorLayer = new VectorLayer({
					source: new VectorSource({
						format: new GeoJSON(),
						loader: () => LayerRegistry.loaderFeatureFromAPI(vectorLayer, RedesDeDrenagemSimplificada)
					}),
					style: null,
					zIndex: 2
				});
				return vectorLayer
			},
			createFeatureSummary: function (feature) {
				const overlayText = Analise.getInstance().getTextToOverlay(feature)

				return new FeatureSummary({
					element: (
						<div key={`${this.id}_${feature.get('FID_1')}`}>
							<label>
								MB{feature.get('FID_1')}
							</label>
							<br />
							<div style={{ marginLeft: 10 }}>
								{overlayText}
							</div>
						</div>),
					order: 20
				});
			}
		});
	}

	createUnidadeConservacaoLayer = () => {
		return new Layer({
			name: 'Unidades de conservação',
			disableSelect: true,
			doCreateOLLayer: function () {
				const vectorLayer = new VectorLayer({
					source: new VectorSource({
						format: new GeoJSON(),
						loader: () => LayerRegistry.loaderFeatureFromAPI(vectorLayer, UnidadesConservacao)
					}),
					style: new Style({
						stroke: new Stroke({
							color: 'green',
							width: 1
						})
					}),
					zIndex: 2
				});
				return vectorLayer
			},
			doCreateLegend: function () {
				return new LayerLegend({
					title: " ",
					order: 2,
					items: [
						new LayerLegendItem({
							description: 'Unidades de conservação',
							icon: 'polygon',
							color: 'green',
							isAssociatedWithFeature: (feature) => true
						})
					]
				});
			}
		});
	}

	createTerrasIndigenasLayer = () => {
		return new Layer({
			name: 'Terras indígenas',
			disableSelect: true,
			doCreateOLLayer: function () {
				const vectorLayer = new VectorLayer({
					source: new VectorSource({
						format: new GeoJSON(),
						loader: () => LayerRegistry.loaderFeatureFromAPI(vectorLayer, TerrasIndigenas)
					}),
					style: new Style({
						stroke: new Stroke({
							color: 'red',
							width: 1
						})
					}),
					zIndex: 2
				});
				return vectorLayer
			},
			doCreateLegend: function () {
				return new LayerLegend({
					title: " ",
					order: 2,
					items: [
						new LayerLegendItem({
							description: 'Terras indígenas',
							icon: 'polygon',
							color: 'red',
							isAssociatedWithFeature: (feature) => true
						})
					]
				});
			}
		});
	}

	createMinasLayer = () => {
		return new Layer({
			name: 'Minas',
			disableSelect: true,
			doCreateOLLayer: function () {
				const style = new Style({
					image: new Icon({
						src: mining,
						scale: 0.08
					}),
					text: new Text({
						font: 'bold 12px "Roboto", "Arial Unicode MS", "sans-serif"',
						stroke: new Stroke({
							color: 'white',
							width: 2
						}),
						placement: 'point',
						textBaseline: 'top',
						offsetY: 13,
						scale: 1
					})
				});

				const vectorLayer = new VectorLayer({
					source: new VectorSource({
						format: new GeoJSON(),
						loader: () => LayerRegistry.loaderFeatureFromAPI(vectorLayer, Minas)
					}),
					style: (feature) => {
						style.getText().setText(feature.get('toponimia'));
						return style;
					},
					zIndex: 2
				});
				return vectorLayer
			},
			doCreateLegend: function () {
				return new LayerLegend({
					title: " ",
					order: 2,
					items: [
						new LayerLegendItem({
							description: 'Minas',
							icon: 'minas',
							color: '',
							isAssociatedWithFeature: (feature) => true
						})
					]
				});
			},
		});
	}

	createLimiarLayer = (dados) => {
		if (!dados || dados.length === 0) return

		const limiaresSolicitados = dados.features.filter(feature => !feature.geometry)[0].properties.limiaresSolicitados
		const layer = new Layer({
			name: dados.name,
			multipleFeaturesSelection: true,
			doCreateOLLayer: function () {
				const vectorLayer = new VectorLayer({
					source: new VectorSource({
						format: new GeoJSON(),
						loader: () => LayerRegistry.loaderFeatures(vectorLayer, dados)
					}),
					style: (feature) => {
						const limiar = limiaresSolicitados.filter(limiar => limiar.id === feature.get('idLimiar'))[0]
						const cor = tipoLimiarColorsForMap.get(limiar.tipo, limiar.superior)

						const style = new Style({
							image: new Circle({
								fill: new Fill({ color: cor }),
								stroke: new Stroke({
									color: '#000',
									width: .6
								}),
								radius: 5
							}),
							fill: new Fill({ color: cor }),
							stroke: new Stroke({
								color: '#000',
								width: .6
							})
						})
						feature.set('originalStylePoint', style, true);
						return style
					},
					zIndex: 3
				});
				return vectorLayer
			},
			doCreateLegend: function () {
				return new LayerLegend({
					title: "Limiares",
					order: 2,
					items: limiaresSolicitados.map(limiar => {
						return new LayerLegendItem({
							description: (limiar.superior ? '> ' : '< ') + limiar.valor.toLocaleString('pt-BR') + (limiar.unidadeParametroAnalise ? ' ' + limiar.unidadeParametroAnalise: "") + ' (' + limiar.nomeTipo + ')',
							icon: 'circle',
							color: tipoLimiarColorsForMap.get(limiar.tipo, limiar.superior),
							isAssociatedWithFeature: (feature) => feature.get('idLimiar') === limiar.id
						})
					})
				});
			},
			createFeatureSummary: function (feature) {
				const limiar = limiaresSolicitados.filter(limiar => limiar.id === feature.get('idLimiar'))[0]
				return new FeatureSummary({
					element: (
						<div key={`${this.id}_${feature.getId()}`}>
							{`${feature.get('codigo')}`}
							<div style={{ marginLeft: 10 }}>
								{`    ${feature.get('dataHoraColeta')}`}
								<br />
								{'    ' + limiar.nomeParametroAnalise + ': ' + feature.get('valorAnaliseConsiderandoLimiteQuantificacao').toLocaleString('pt-BR') + (limiar.unidadeParametroAnalise ? ' ' + limiar.unidadeParametroAnalise: "") + (limiar.superior ? ' > ' : ' < ') + limiar.nomeTipo + ' ( ' + limiar.valor.toLocaleString('pt-BR') + (limiar.unidadeParametroAnalise ? ' ' + limiar.unidadeParametroAnalise: "") + ' )'}
							</div>
						</div>
					),
					order: 2
				});
			}
		});
		this.setLimilarLayer(layer)
		return layer
	}

	createAmostraLayer = () => {
		return new Layer({
			name: 'Amostragem',
			multipleFeaturesSelection: true,
			doCreateOLLayer: function () {
				const vectorLayer = new VectorLayer({
					source: new VectorSource({
						format: new GeoJSON()
					}),
					style: (feature) => new Style({
						image: new Circle({
							fill: new Fill({ color: feature.get('cor') }),
							stroke: new Stroke({
								color: '#000',
								width: .6
							}),
							radius: 5
						})
					}),
					zIndex: 3
				});
				return vectorLayer
			},
			doCreateLegend: function () {
				return new LayerLegend({
					title: "Amostragem",
					order: 2,
					items: [
						new LayerLegendItem({
							description: 'Analisada',
							icon: 'circle',
							isAssociatedWithFeature: (feature) => true
						})
					]
				});
			},
			createFeatureSummary: function (feature) {
				return new FeatureSummary({
					element: (<div key={`${this.id}_${feature.get('id')}`}>{'Coletada em ' + feature.get('dataHoraColeta')}</div>),
					order: 10
				});
			}
		})
	}

	createGeologiaLayer = () => {
		return new Layer({
			name: 'Geologia',
			doCreateOLLayer: function () {
				const vectorLayer = new VectorLayer({
					source: new VectorSource({
						format: new GeoJSON(),
						loader: () => LayerRegistry.loaderFeatureFromAPI(vectorLayer, Geologia)
					}),
					style: (feature) => new Style({
						fill: new Fill({ color: feature.get('cor') }),
					}),
					zIndex: 1
				});
				return vectorLayer
			},
			createFeatureSummary: function (feature) {
				return new FeatureSummary({
					element: (
						<div key={`${this.id}_${feature.getId()}`}>
							<label style={{ fontWeight: "bold" }}>
								{feature.get('dominio')}
							</label>
							<br />
							<label style={{ marginLeft: 10 }}>
								{feature.get('NOME_UNIDA')}
							</label>
						</div>),
					order: 10
				});
			}
		});
    }
    
    createSoloLayer = async (dados) => {
        if (!dados) return
        
        let grupoSolo
        if (dados.contrastar)
            grupoSolo = await GruposAnaliseContrasteSolo(dados.idParametroAnalise, dados.idSerieAnalise);
        else
            grupoSolo = await GrupoAnaliseSolo(dados.idParametroAnalise, dados.idSerieAnalise);

		const soloLayer = new Layer({
            name: dados.nome,
            multipleFeaturesSelection: true,
			doCreateOLLayer: function () {
				const vectorLayer = new VectorLayer({
					source: new VectorSource({
						format: new GeoJSON(),
						loader: async () => {
                            let shapeSolo
                            if (dados.contrastar)
                                shapeSolo = await ShapeAnaliseContrasteSolo(dados.idParametroAnalise, dados.idSerieAnalise);
                            else
                                shapeSolo = await ShapeAnaliseSolo(dados.idParametroAnalise, dados.idSerieAnalise);
                            return LayerRegistry.loaderFeatures(vectorLayer, shapeSolo)

                        }
                    }),
                    style: null,
					zIndex: 1
				});
				return vectorLayer
            },
            createFeatureSummary: (feature) => {
                const grupo = grupoSolo.filter(g => g.id === feature.get('gridcode'))[0]
				return new FeatureSummary({
					element: (
						<div key={`${this.id}_${feature.get('gridcode')}`}>
							<label style={{ fontWeight: "bold" }}>
								{`Análise`}
							</label>
							<br />
							<label style={{ marginLeft: 10 }}>
                                {dados.contrastar ? 
                                    `${dados.parametro} (contraste): ${grupo.inicio} - ${grupo.fim}`
                                    :
                                    `${dados.parametro}: ${grupo.inicio} / ${grupo.fim} %`
                                }
                                <div style={{ marginLeft: 10 }}>{dados.contrastar && `Superficial / Subsuperficial`}</div>
							</label>
						</div>
					),
					order: 10
				});
			}
        });
        this.setSoloLayer(soloLayer)
        return soloLayer;
	}
}

export default (new LayerRegistry())